/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_plan_area_id: z.string().uuid(),
  material_id: z.number(),
  work_detail_id: z.number().nullable(),
  planned_qty: z.number(),
  unit: z.string(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  work_detail_id: base.shape.work_detail_id.optional(),
  planned_qty: base.shape.planned_qty.optional(),
  unit: base.shape.unit.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionPlanAreaPlannedMaterialBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionPlanAreaPlannedMaterialBase = z.infer<typeof base>;
export type ConstructionPlanAreaPlannedMaterialBasePutPayload = z.infer<typeof put>;
export type ConstructionPlanAreaPlannedMaterialBasePatchPayload = z.infer<typeof patch>;
export type ConstructionPlanAreaPlannedMaterialBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionPlanAreaPlannedMaterialBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionPlanAreaPlannedMaterialBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionPlanAreaPlannedMaterialBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionPlanAreaPlannedMaterialBaseCachesAttributes = z.infer<typeof caches>;